import { render, staticRenderFns } from "./majorDetails.vue?vue&type=template&id=3cdd3d1b&scoped=true&"
import script from "./majorDetails.vue?vue&type=script&lang=js&"
export * from "./majorDetails.vue?vue&type=script&lang=js&"
import style0 from "./majorDetails.vue?vue&type=style&index=0&id=3cdd3d1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdd3d1b",
  null
  
)

export default component.exports